// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers';
export class EdgeWaypoint {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsEdgeWaypoint(bb, obj) {
        return (obj || new EdgeWaypoint()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsEdgeWaypoint(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new EdgeWaypoint()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    x() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
    }
    y() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
    }
    static startEdgeWaypoint(builder) {
        builder.startObject(3);
    }
    static addId(builder, idOffset) {
        builder.addFieldOffset(0, idOffset, 0);
    }
    static addX(builder, x) {
        builder.addFieldFloat64(1, x, 0.0);
    }
    static addY(builder, y) {
        builder.addFieldFloat64(2, y, 0.0);
    }
    static endEdgeWaypoint(builder) {
        const offset = builder.endObject();
        builder.requiredField(offset, 4); // id
        return offset;
    }
    static createEdgeWaypoint(builder, idOffset, x, y) {
        EdgeWaypoint.startEdgeWaypoint(builder);
        EdgeWaypoint.addId(builder, idOffset);
        EdgeWaypoint.addX(builder, x);
        EdgeWaypoint.addY(builder, y);
        return EdgeWaypoint.endEdgeWaypoint(builder);
    }
}
//# sourceMappingURL=edge-waypoint.js.map